<template>
  <div>
    <el-table
        v-if="getNoWOList.length>0"
        :data="getNoWOList"
        style="width: 100%">
        <el-table-column 
        label="Garment">
        <template slot-scope="scope">
           {{scope.row.tailoring_detail.template_name}}
        </template>
        </el-table-column>
        <el-table-column 
        label="Qty" align="center">
        <template slot-scope="scope">
            {{parseInt(scope.row.tailoring_qty)-getDistinctSaleItemId.filter(t => t.sale_item_id === scope.row.id).length}}
        </template>
        </el-table-column>
        <el-table-column 
        label="Fabric" align="center">
        <template slot-scope="scope">
            <div>
                <span v-if="scope.row.fabric_id>0 && scope.row.fabric_detail">
                {{scope.row.fabric_detail.sku_code}}
                </span>
            </div>
        </template>
        </el-table-column>
        <el-table-column 
        prop="process_name"
        label="Current Status">
        <template>
            WO Pending
        </template>
        </el-table-column>
        
    </el-table>
    
    <el-table
        :data="getDistinctSingleItemList"
        style="width: 100%">
        <el-table-column 
        label="Garment">
        <template slot-scope="scope">
            {{scope.row.template_name}}
        </template>
        </el-table-column>
        <el-table-column 
        label="Qty" align="center">
        <template slot-scope="scope">
            {{data_list.filter(t => t.tailoring_item_id === scope.row.tailoring_item_id && t.sub_tailoring_item_id === scope.row.sub_tailoring_item_id && t.process_name == scope.row.process_name && t.delivered === scope.row.delivered && t.fabric_id === scope.row.fabric_id).length}}
        </template>
        </el-table-column>
        <el-table-column 
        label="Fabric" align="center">
        <template slot-scope="scope">
            <div>
                <span>
                {{scope.row.sku_code}}
                </span>
            </div>
        </template>
        </el-table-column>
        <el-table-column 
        prop="process_name"
        label="Current Status">
        <template slot-scope="scope">
            <span v-if="scope.row.delivered === 1">
                Delivered
            </span>
            <span v-else>
                {{scope.row.process_name+' '+(scope.row.hidden_process === -1 ? scope.row.work_order_status : '')}}
            </span>
        </template>
        </el-table-column>
        
    </el-table>

    <el-table
        v-if="getDistinctComboItemList.length>0"
        :data="getDistinctComboItemList"
        style="width: 100%">
        <el-table-column 
        label="Garment">
        <template slot-scope="scope">
           {{scope.row.sub_template_name}} ({{scope.row.template_name}})
        </template>
        </el-table-column>
        <el-table-column 
        label="Qty" align="center">
        <template slot-scope="scope">
            {{data_list.filter(t => t.tailoring_item_id === scope.row.tailoring_item_id && t.sub_tailoring_item_id === scope.row.sub_tailoring_item_id && t.process_name == scope.row.process_name && t.delivered === scope.row.delivered && t.fabric_id === scope.row.fabric_id).length}}
        </template>
        </el-table-column>
        <el-table-column 
        label="Fabric" align="center">
        <template slot-scope="scope">
            <div>
                <span>
                {{scope.row.sku_code}}
                </span>
            </div>
        </template>
        </el-table-column>
        <el-table-column 
        prop="process_name"
        label="Current Status">
        <template slot-scope="scope">
            <span v-if="scope.row.delivered === 1">
                Delivered
            </span>
            <span v-else>
                {{scope.row.process_name+' '+(scope.row.hidden_process === -1 ? scope.row.work_order_status : '')}}
            </span>
        </template>
        </el-table-column>
        
    </el-table>
        
  </div>
</template>

<script>
export default {
    props: ['data_list'],
    computed: {
        getNoWOList() {
            return this.$store.getters.getSaleMasterDataProps.item_list.filter(t => t.work_order_id === 0 && t.tailoring_item_id>0)
        },
        getDistinctSaleItemId() {
            return this.data_list.filter((thing, index, self) => index === self.findIndex((t) => (t.sale_item_id === thing.sale_item_id && t.qty_sl_no === thing.qty_sl_no)))
        },
        getDistinctSingleItemList() {
            return this.data_list.filter((thing, index, self) =>
                index === self.findIndex((t) => (t.tailoring_item_id === thing.tailoring_item_id 
                    && t.sub_tailoring_item_id === null 
                        && t.process_name === thing.process_name 
                            && t.delivered === thing.delivered 
                                && t.fabric_id === thing.fabric_id))
            )
        },
        getDistinctComboItemList() {
            return this.data_list.filter((thing, index, self) =>
                index === self.findIndex((t) => (t.tailoring_item_id === thing.tailoring_item_id 
                    && t.sub_tailoring_item_id !== null 
                        && t.process_name === thing.process_name 
                            && t.delivered === thing.delivered 
                                && t.fabric_id === thing.fabric_id))
            )
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/SaleMaster/QuickDetail/GroupProductionStatus.vue